// @ts-nocheck
import * as React from "react";
import { MetricDrilldownModal } from "./MetricDrilldownModal";

// 남양주 12단계 흐름(A1 위젯) 카드 클릭 시 열리는 단계별 건 목록.
// 이전에는 카드 클릭이 /cases 같은 화면으로 그냥 이동해서 "그 단계의 건"이 하나도
// 걸러지지 않았다. 이제 카드 숫자를 만든 그 스코프(dashboards#region_service_flow_items)를
// 그대로 페이징해 보여준다. 표 렌더·페이징·에러 처리는 공용 MetricDrilldownModal 담당.
export function ServiceFlowDrilldownModal({ stage, regionCode, onClose }) {
  return (
    <MetricDrilldownModal
      endpoint="/api/v1/dashboard/region/service_flow/items"
      params={{ stage: stage?.key }}
      regionCode={regionCode}
      title={
        <>
          {stage?.step != null && (
            <span className="muted mono" style={{ fontSize: 12, fontWeight: 600, marginRight: 6 }}>{stage.step}단계</span>
          )}
          {stage?.label || "단계"}
        </>
      }
      columns={["대상", "내용", "상태", "일자"]}
      emptyText="이 단계에 해당하는 건이 없습니다."
      onClose={onClose}
    />
  );
}
